import { createRootRoute } from '@tanstack/react-router';

import { AuthGate } from '@/auth/AuthGate';
import { NotFoundView } from '@/components/app/NotFoundView';
import { RootLayout } from '@/layouts/RootLayout';

export const Route = createRootRoute({
    component: () => (
        <AuthGate>
            <RootLayout />
        </AuthGate>
    ),
    notFoundComponent: NotFoundView,
});
